import { PropTypes } from 'prop-types';

export const profilePropType = PropTypes.shape({});
export const childrenPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node,
]);
